export enum TerminationCategoryEnum {
    medical_leave = "medical_leave",
    contract_termination = "contract_termination",
}

export class TerminationCategory {
    constructor(
        public readonly key: TerminationCategoryEnum,
        public readonly value: string,
    ) {}
}
